<ion-card>
  <ion-card-header>
    <ion-card-title>Példányok és átadás-átvétel</ion-card-title>
    <ion-card-subtitle>
      Az irat a tartalom, a példány a megjelenése – eredeti, másolat vagy hiteles
      másolat, őrzővel és hellyel. Átadásnál a felelősség csak az átvétel
      visszaigazolásakor száll át.
    </ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <ion-segment [(ngModel)]="nezet" mode="ios">
      <ion-segment-button value="peldanyok"><ion-label>Példányok</ion-label></ion-segment-button>
      <ion-segment-button value="atadas"><ion-label>Átadás-átvétel</ion-label></ion-segment-button>
    </ion-segment>

    <div class="ikt-fejsor">
      <ion-searchbar placeholder="Keresés iktatószámra, tárgyra, vonalkódra…" [(ngModel)]="szoveg"
                     [debounce]="300" (ionChange)="betolt()"></ion-searchbar>
      <ion-checkbox labelPlacement="end" [checked]="csakSajat"
                    (ionChange)="csakSajat = $event.detail.checked; betolt()">
        Csak ami hozzám tartozik
      </ion-checkbox>
    </div>

    <div *ngIf="betoltes" class="ion-text-center ion-padding"><ion-spinner name="crescent"></ion-spinner></div>

    <!-- Példányok -->
    <div class="ikt-tabla-doboz" *ngIf="nezet === 'peldanyok' && !betoltes">
      <table class="ikt-tabla">
        <thead>
          <tr><th>Iktatószám</th><th>Tárgy</th><th class="szam">Példány</th><th>Típus</th>
              <th>Hordozó</th><th>Őrző</th><th>Hely</th><th>Vonalkód</th><th>Állapot</th><th>Művelet</th></tr>
        </thead>
        <tbody>
          <tr *ngFor="let p of peldanyok">
            <td class="iktszam" (click)="iratra(p)" style="cursor:pointer">{{ p.iktatoszam }}</td>
            <td>{{ p.targy }}</td>
            <td class="szam">{{ p.sorszam }}.</td>
            <td>{{ p.tipus }}</td>
            <td>{{ p.adathordozo }}</td>
            <td>{{ p.orzo_nev || p.orzo || '—' }}</td>
            <td>{{ p.hely || '—' }}</td>
            <td class="szam">{{ p.vonalkod }}</td>
            <td><ion-badge [color]="allapotSzin(p)">{{ p.allapot }}</ion-badge></td>
            <td>
              <ion-button size="small" fill="clear" *ngIf="!p.folyamatban_atadas" (click)="atad(p)">
                Átadás
              </ion-button>
              <ion-note color="medium" *ngIf="p.folyamatban_atadas" style="font-size:.76rem">
                átvételre vár
              </ion-note>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="ikt-ures" *ngIf="!peldanyok.length">
        Még nincs nyilvántartott példány. Az irat oldaláról hozhatsz létre újat.
      </div>
    </div>

    <!-- Átadókönyv -->
    <div class="ikt-tabla-doboz" *ngIf="nezet === 'atadas' && !betoltes">
      <table class="ikt-tabla">
        <thead>
          <tr><th>Iktatószám</th><th>Tárgy</th><th>Átadó</th><th>Átvevő</th>
              <th class="szam">Átadva</th><th class="szam">Átvéve</th><th>Állapot</th><th>Művelet</th></tr>
        </thead>
        <tbody>
          <tr *ngFor="let a of atadasok" [class.ervenytelen]="a.statusz === 'visszautasitva'">
            <td class="iktszam">{{ a.iktatoszam }}</td>
            <td>{{ a.targy }}</td>
            <td>{{ a.atado_nev || a.atado }}</td>
            <td>{{ a.atvevo_nev || a.atvevo }}</td>
            <td class="szam">{{ a.atadva | date:'yyyy-MM-dd HH:mm' }}</td>
            <td class="szam">{{ a.atveve ? (a.atveve | date:'yyyy-MM-dd HH:mm') : '—' }}</td>
            <td>
              <ion-badge [color]="a.statusz === 'atveve' ? 'success' : (a.statusz === 'visszautasitva' ? 'danger' : 'warning')">
                {{ a.statusz }}
              </ion-badge>
              <div style="font-size:.74rem" *ngIf="a.visszautasitas_indok">{{ a.visszautasitas_indok }}</div>
            </td>
            <td>
              <ng-container *ngIf="a.statusz === 'folyamatban' && a.atvevo === en">
                <ion-button size="small" fill="clear" color="success" (click)="atvesz(a)">Átveszem</ion-button>
                <ion-button size="small" fill="clear" color="danger" (click)="visszautasit(a)">Visszautasít</ion-button>
              </ng-container>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="ikt-ures" *ngIf="!atadasok.length">Nincs átadási bejegyzés.</div>
    </div>
  </ion-card-content>
</ion-card>
